"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/fileImg/index.vue"));
var _banner = require("@/api/banner/banner");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      swiperInfo: {
        id: "",
        imageUrl: "",
        linkUrl: "",
        name: ""
      },
      imageUrl: ""
    };
  },
  methods: {
    successUpLoad: function successUpLoad(e) {
      this.swiperInfo.imageUrl = e.ossOriUrl;
    },
    submit: function submit() {
      var _this = this;
      (0, _banner.editBanner)(this.swiperInfo).then(function () {
        _this.$message.success("操作成功。");
        _this.$router.push("/webSet/webSet-swiper");
      });
    },
    isBack: function isBack() {
      this.$router.push("/webSet/webSet-swiper");
    }
  },
  created: function created() {
    this.swiperInfo = this.$route.query;
  },
  components: {
    FileImg: _index.default
  }
};